import PageKey from "config/PageKey";

import { IRolePageTranslation } from "models/translation";

import defaultsWithFallback from "helpers/defaultsWithFallback";
import { fallbackTranslation } from "services/api/fallbackData";
import {
  IPatchSuggestionEditMap,
  PatchOperation,
} from "services/api/suggestions/suggestionsService.types";

export interface IRoleSuggestionsViewTexts {
  makeSuggestionActionCancel: string;
  makeSuggestionActionEdit: string;
  makeSuggestionActionNudge: string;
  makeSuggestionActionRemove: string;
  makeSuggestionActionSubmit: string;
  makeSuggestionLabelActionDisabled: string;
  makeSuggestionLabelMessagePlaceholder: string;
  makeSuggestionLabelNudge: string;
  makeSuggestionLabelNudgeDetails: string;
  makeSuggestionLabelSelectPhoto: string;
  makeSuggestionLabelSent: string;
  makeSuggestionLabelSuggestionDetails: string;
  makeSuggestionLabelSuggestionMessage: string;
  makeSuggestionLabelSuggestionNote: string;
  makeSuggestionLabelTitle: string;
  makeSuggestionMessageReadAccess: string;
  makeSuggestionTitleSuggestionMessage: string;
  makeSuggestionMessageTooltipText: string;
  makeSuggestionMessageTooltipTitle: string;
  makeSuggestionSelectPhotoTooltipText: string;
  makeSuggestionSelectPhotoTooltipTitle: string;
  makeSuggestionLabelNudgeAgent: string;
  makeSuggestionIsRoleCastButtonText: string;
  makeSuggestionIsRoleCastNudgeButtonText: string;
}

const fallbackPageTranslation = fallbackTranslation[PageKey.Role];

export function prepareTexts(
  pageTranslation: IRolePageTranslation
): IRoleSuggestionsViewTexts {
  return defaultsWithFallback(
    pageTranslation?.makeSuggestion,
    fallbackPageTranslation.makeSuggestion
  );
}

export function getPatch(
  photo: string,
  comment: string,
  suggestionId: string
): IPatchSuggestionEditMap {
  return {
    [suggestionId]: [
      { op: PatchOperation.Replace, path: "/comment", value: comment },
      { op: PatchOperation.Replace, path: "/photo", value: photo },
    ],
  };
}
